import {
  createContext,
  useContext,
} from "react"
import type { ReadOnlyUserEvent } from "src/types"

interface OpenEventModal {
  userEvent?: ReadOnlyUserEvent;
}

export interface EventModalPublicContextValue {
  closeEventModal: () => void;
  openEventModal: (args?: OpenEventModal) => void;
}

type ContextType = EventModalPublicContextValue | null
export const EventModalPublicContext = createContext<ContextType>(null)

export function useEventModalPublicContext() {
  const context = useContext(EventModalPublicContext)

  if (context === null) {
    throw new Error("EventModal components must be wrapped in <EventModalPublicContext />")
  }

  return context
}
